(ns hai.ui.components.form.select.single-select
  (:require
   [clojure.edn :as edn]
   [hai.ui.components :as c]))

(defn field
  [{:form.field/keys [current-value set-value! placeholder full-width?]
    :form.field.select/keys [options]
    :or {full-width? true}}]
  ;; TODO move schema here and add validation
  [c/SelectRoot
   (cond-> {:onValueChange (comp set-value! edn/read-string)}
     ;; TODO this precludes `nil` as a valid value, not sure this is ever going to be a problem as a
     ;; `nil` value should be no attr present form value?
     current-value (assoc :defaultValue (pr-str current-value)))
   [c/SelectTrigger (merge
                     (when full-width?
                       {:style {:width "100%"}})
                     {:placeholder placeholder})]
   (into [c/SelectContent]
         (map (fn [{:keys [value title]}]
                [c/SelectItem {:value (pr-str value)} title]))
         options)])

;; TODO this is a duplication of the above without :width "100%"
(defn field-slim
  [{:form.field/keys [current-value set-value! placeholder]
    :form.field.select/keys [options]}]
  ;; TODO move schema here and add validation
  [c/SelectRoot
   (cond-> {:onValueChange (comp set-value! edn/read-string)}
     ;; TODO this precludes `nil` as a valid value, not sure this is ever going to be a problem as a
     ;; `nil` value should be no attr present form value?
     current-value (assoc :defaultValue (pr-str current-value)))
   [c/SelectTrigger {:placeholder placeholder}]
   (into [c/SelectContent]
         (map (fn [{:keys [value title]}]
                [c/SelectItem {:value (pr-str value)} title]))
         options)])
